module.exports = [{"value":"ประถมศึกษา","text":"ประถมศึกษา"},{"value":"มัธยมศึกษาตอนต้น","text":"มัธยมศึกษาตอนต้น"},{"value":"มัธยมศึกษาตอนปลาย/ปวช.","text":"มัธยมศึกษาตอนปลาย/ปวช."},{"value":"อนุปริญญา/ปวส.","text":"อนุปริญญา/ปวส."},{"value":"ปริญญาเอก","text":"ปริญญาเอก"},{"value":"ปริญญาโท","text":"ปริญญาโท"},{"value":"ปริญญาตรี","text":"ปริญญาตรี"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/Education/educationLavel.json
// module id = nWwR
// module chunks = 2